<!-- ========== App Menu ========== -->
<div class="app-menu navbar-menu">
  <!-- LOGO -->
  <div class="navbar-brand-box d-block">
    <!-- Dark Logo-->
    <a routerLink="/" class="logo logo-dark">
      <span class="logo-sm">
        <img src="assets/images/logo-light-sm.svg" alt="" height="28">
      </span>
      <span class="logo-lg">
        <img src="assets/images/logo-light.svg" alt="" height="36">
      </span>
    </a>
    <!-- Light Logo-->
    <a routerLink="/" class="logo logo-light">
      <span class="logo-sm">
        <img src="assets/images/logo-light-sm.svg" alt="" height="28">
      </span>
      <span class="logo-lg">
        <img src="assets/images/logo-light.svg" alt="" height="36">
      </span>
    </a>

    <button type="button" class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover"
      (click)="toggleMobileMenu($event)">
      <i class="ri-record-circle-line"></i>
    </button>
  </div>


  <!-- User Info -->
  <!-- <div class="text-center menu-avatar">
  <div class="avatar-lg text-center m-auto">
    <img [src]="userAvatar || 'assets/images/companies/default.png'" alt="user-img"
      class="img-thumbnail rounded-circle wh-96 object-fit-cover" />
    </div>
    <h3 class="text-white mb-1 mt-2 fs-14">{{userData?.fullName}}</h3>
  </div> -->
  <div id="scrollbar">
    <div class="container-fluid">
      <div id="two-column-menu">
      </div>
      <ngx-simplebar class="sidebar-menu-scroll" style="max-height: calc(100vh - 245px)">
        <ul class="metismenu list-unstyled navbar-nav m-0 p-0" id="navbar-nav">

          @for (item of menuItems; track item.id) {
          @if (item.isTitle) {
          <li class="menu-title"><span data-key="t-menu">{{ item.label | translate }}</span></li>
          }
          @if (!item.isTitle && !item.isLayout) {
          <li class="nav-item">
            @if (hasItems(item)) {
            <a href="javascript:void(0);" class="is-parent nav-link menu-link" [class.has-arrow]="!item.badge"
              [class.has-dropdown]="item.badge" [class.disabled]="item.disabled" [class.opacity-50]="item.disabled"
              data-bs-toggle="collapse" aria-expanded="false" (click)="toggleItem($event,item)">
              <i class="{{ item.icon }} icon nav-icon" class=""></i>
              <span class=""> {{ item.label | translate }}</span>
              @if (item.badge) {
              <span class="badge badge-pill {{item.badge.variant}}">{{item.badge.text |
                translate}}</span>
              }
            </a>
            }
            @if (!hasItems(item)) {
            <a [routerLink]="item.link" class="side-nav-link-ref nav-link menu-link" [class.disabled]="item.disabled"
              [class.opacity-50]="item.disabled" (click)="toggleParentItem($event)">
              @if (item.icon) {
              <i class="bx {{ item.icon }} icon nav-icon" class=""></i>
              }
              <span class=""> {{ item.label | translate }}</span>
              @if (item.badge) {
              <span class="badge badge-pill {{item.badge.variant}}">{{ item.badge.text |
                translate}}</span>
              }
            </a>
            }
            @if (hasItems(item)) {
            <div class="collapse menu-dropdown">
              @if (hasItems(item)) {
              <ul class="nav nav-sm flex-column ps-1" aria-expanded="false">
                @for (subitem of item.subItems; track subitem.id) {
                <li class="nav-item">
                  <!-- here -->
                  @if (!hasItems(subitem)) {
                  <a [routerLink]="subitem.link" class="nav-link text-white" [class.disabled]="subitem.disabled"
                    [class.opacity-50]="subitem.disabled" [attr.data-parent]="subitem.parentId"
                    (click)="updateActive($event)">
                    <i class="{{ subitem.icon }} icon nav-icon" class=""></i>
                    {{ subitem.label | translate}}
                    @if (subitem.badge) {
                    <span class="badge badge-pill {{subitem.badge.variant}}">{{subitem.badge.text
                      | translate}}</span>
                    }
                  </a>
                  }
                  @if (hasItems(subitem)) {
                  <a class="nav-link" href="javascript:void(0);" [attr.data-parent]="subitem.parentId"
                    data-bs-toggle="collapse" aria-expanded="false" (click)="toggleSubItem($event)">
                    {{ subitem.label | translate}}
                    @if (subitem.badge) {
                    <span class="badge badge-pill {{subitem.badge.variant}}">{{subitem.badge.text
                      | translate}}</span>
                    }
                  </a>
                  }
                  @if (hasItems(subitem)) {
                  <div class="collapse menu-dropdown sub-menu">
                    @if (hasItems(subitem)) {
                    <ul class="nav nav-sm flex-column" aria-expanded="false">
                      @for (subSubitem of subitem.subItems; track subSubitem.id) {
                      <li class="nav-item">
                        @if (!hasItems(subSubitem)) {
                        <a [routerLink]="subSubitem.link" class="nav-link" [attr.data-parent]="subSubitem.parentId"
                          (click)="updateActive($event)">
                          {{ subSubitem.label | translate}}
                        </a>
                        }
                        @if (hasItems(subSubitem)) {
                        <a class="nav-link" href="javascript:void(0);" [attr.data-parent]="subSubitem.parentId"
                          data-bs-toggle="collapse" aria-expanded="false" (click)="toggleExtraSubItem($event)">
                          {{ subSubitem.label | translate}}
                          @if (subSubitem.badge) {
                          <span class="badge badge-pill {{subSubitem.badge.variant}}">{{subSubitem.badge.text
                            | translate}}</span>
                          }
                        </a>
                        }
                        @if (hasItems(subSubitem)) {
                        <div class="collapse menu-dropdown extra-sub-menu">
                          @if (hasItems(subSubitem)) {
                          <ul class="nav nav-sm flex-column" aria-expanded="false">
                            @for (subSubitem1 of subSubitem.subItems; track subSubitem1.id) {
                            <li class="nav-item">
                              <a [attr.data-parent]="subSubitem1.parentId" [routerLink]="subSubitem1.link"
                                class="nav-link" (click)="updateActive($event)">
                                {{ subSubitem1.label | translate }}
                              </a>
                            </li>
                            }
                          </ul>
                          }
                        </div>
                        }
                      </li>
                      }
                    </ul>
                    }
                  </div>
                  }
                </li>
                }
              </ul>
              }
            </div>
            }
          </li>
          }
          }
          <!-- <ng-container>
          <li class="nav-item">
            <a class="side-nav-link-ref nav-link menu-link"
              href="https://forms.clickup.com/42085814/f/184bdp-2200/6IUCHV40DA7J5AED2H" target="_blank"
              rel="noopener">
              <i class="bx bx-support icon nav-icon"></i>
              <span> {{ 'COMMON.SUPPORT' | translate}} </span>
            </a>
          </li>
        </ng-container> -->
        </ul>
      </ngx-simplebar>
    </div>
    <!-- Sidebar -->
  </div>
  <div class="user-side-menu">
    <div class="border-bottom user-side-menu-border mx-2 mb-4"></div>
    <ul class="metismenu list-unstyled navbar-nav m-0 p-0">
      <li class="nav-item">
        <a class="side-nav-link-ref nav-link menu-link" routerLink="/notifications">
          <i class="bx bx-bell icon nav-icon"></i>
          <span>
            {{ 'COMMON.NOTIFICATIONS' | translate }}
            @if (unReadNotificationsCount > 0) {
            <span
              class="position-absolute topbar-badge fs-12 translate-middle badge rounded-circle bg-danger d-flex justify-content-center align-items-center"
              style="width: 24px; height: 24px;">
              {{unReadNotificationsCount}}
            </span>
            }

          </span>
        </a>
      </li>
      <!-- <li class="nav-item">
    <a class="side-nav-link-ref nav-link menu-link" routerLink="/setting">
      <i class="ri-settings-3-line icon nav-icon"></i>
      <span> {{ 'COMMON.SETTING' | translate}} </span>
    </a>
  </li> -->
    </ul>
    <ul class="metismenu list-unstyled navbar-nav m-0 p-0">
      <li class="nav-item" ngbDropdown>
        <div class="side-nav-link-ref nav-link menu-link arrow-none user-link" href="javascript:void(0);"
          data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle role="button">
          <i class="icon nav-icon">
            <img class="rounded-circle header-profile-user" [src]="userAvatar" alt="Header Avatar">
          </i>
          <div class="user-side-details ps-2 text-truncate">
            <div class="ms-1 fw-medium user-name-text">{{userData?.fullName}}</div>
            <div class="ms-1 fs-12 text-muted user-name-sub-text text-truncate">{{userData?.email}}</div>
          </div>
          <i class="las fs-20 ms-auto min-wh-auto"
            [class]="currentLang == 'en' ? 'la-angle-right' : 'la-angle-left'"></i>
        </div>
        <div class="dropdown-menu dropdown-menu-start" ngbDropdownMenu
          [class]="currentLang == 'en' ? 'user-side-dropdown-left' : 'user-side-dropdown-right'">
          <!-- item-->
          <!-- <h6 class="dropdown-header">{{'COMMON.WELCOME' | translate}} {{userData.fullName}}!</h6> -->
          <a class="dropdown-item" routerLink="/profile"><i
              class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> <span
              class="align-middle">{{'COMMON.PROFILE' | translate}}</span>
          </a>

          <a class="dropdown-item" href="javascript: void(0);" (click)="logout()"><i
              class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span class="align-middle"
              data-key="t-logout">{{'COMMON.LOGOUT' | translate}}</span></a>
        </div>
      </li>
    </ul>
  </div>

  <div class="sidebar-background"></div>
</div>
<!-- Left Sidebar End -->
<!-- Vertical Overlay-->
<div class="vertical-overlay" (click)="SidebarHide()"></div>